// src/pages/ParaSeuCondominio.js
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './ParaSeuCondominio.css';
import ContactForm from '../components/ContactForm';
import logoPts from '../assets/intelbras/logo-pts.png';
import logoIntelbras from '../assets/intelbras/logo-intelbras.png';

// --- IMPORTAÇÃO DAS IMAGENS ---

// Imagens do NOVO Banner (adicione-as na pasta 'src/assets/banners/')
import bannerFacial from '../assets/banners/Facial-1.jpg';
import bannerTermica from '../assets/banners/Camera-Termica-8.jpg';
import bannerSolar from '../assets/banners/Solar.jpg';
import bannerAcessoVeicular from '../assets/banners/Controle-de-acesso-3.jpg';
import bannerFechadura from '../assets/banners/Fechadura-Digital.jpg';

// Imagens do Infográfico
import bgInfografico from '../assets/intelbras/condominio/bg-infografico.jpg';
import iconControleAcesso from '../assets/intelbras/condominio/icon-controle-acesso.png';
import iconComunicacao from '../assets/intelbras/condominio/icon-comunicacao-condominial.png';
import iconCftv from '../assets/intelbras/condominio/icon-cftv.png';
import iconAlarme from '../assets/intelbras/condominio/icon-alarme-perimetral.png';
import iconIncendio from '../assets/intelbras/condominio/icon-incendio.png';
import iconIluminacao from '../assets/intelbras/condominio/icon-iluminacao-emergencia.png';
import iconRadio from '../assets/intelbras/condominio/icon-radio.png';
import iconInfra from '../assets/intelbras/condominio/icon-infra-internet.png';
import iconPresenca from '../assets/intelbras/condominio/icon-sensor-presenca.png';
import iconEnergia from '../assets/intelbras/condominio/icon-energia-solar.png';
import iconControleVideo from '../assets/intelbras/condominio/icon-controle-acesso-video.png';

// Imagens da Galeria
import galleryCercaEletrica from '../assets/intelbras/condominio/gallery-cerca-eletrica.jpg';
import galleryLinhaVirtual from '../assets/intelbras/condominio/gallery-linha-virtual.jpg';
import galleryCameraElevador from '../assets/intelbras/condominio/gallery-camera-elevador.jpg';
import galleryAbandonoObjeto from '../assets/intelbras/condominio/gallery-abandono-objeto.jpg';
import galleryIntertravamento from '../assets/intelbras/condominio/gallery-intertravamento.jpg';
import galleryDeteccaoFace from '../assets/intelbras/condominio/gallery-deteccao-face.jpg';
import galleryCameraWifi from '../assets/intelbras/condominio/gallery-camera-wifi.jpg';
import galleryCercaVirtual from '../assets/intelbras/condominio/gallery-cerca-virtual.jpg';
import galleryEnergiaSolar from '../assets/intelbras/condominio/gallery-energia-solar.jpg';
import galleryAntiEsmagamento from '../assets/intelbras/condominio/gallery-anti-esmagamento.jpg';
import galleryPortalAutonomo from '../assets/intelbras/condominio/gallery-portal-autonomo.jpg';
import galleryMonitoramentoEnergia from '../assets/intelbras/condominio/gallery-monitoramento-energia.jpg';
import galleryAdeusChaves from '../assets/intelbras/condominio/gallery-adeus-chaves.jpg';
import galleryAppPrediotech from '../assets/intelbras/condominio/gallery-app-prediotech.jpg';
import galleryPosteCFTV from '../assets/intelbras/condominio/poste-cftv.jpg';

// DADOS PARA O NOVO BANNER
const bannerSlides = [
    { id: 1, imagem: bannerFacial, titulo: 'Controle de Acesso', subtitulo: 'Reconhecimento facial com velocidade e precisão' },
    { id: 2, imagem: bannerTermica, titulo: 'Câmera térmica', subtitulo: 'Identificação rápida da temperatura corporal' },
    { id: 3, imagem: bannerSolar, titulo: 'Energia Solar', subtitulo: 'Economia para o seu condomínio' },
    { id: 4, imagem: bannerAcessoVeicular, titulo: 'Controle de acesso', subtitulo: 'Acesso via tag e entrada automática de veículos' },
    { id: 5, imagem: bannerFechadura, titulo: 'Fechadura digital', subtitulo: 'Abra o seu lar sem utilizar chaves' }
];

const solucoesCondominio = [
  { id: 'comunicacao', nome: 'Central de Comunicação condominial', icone: iconComunicacao, texto: 'As Centrais de Comunicação Condominial da Intelbras oferecem segurança e comodidade aos moradores, além de facilitar o trabalho do porteiro. Com elas é possível transferir chamadas, identificar ramais e conversar com apartamentos ou blocos.' },
  { id: 'controle-acesso', nome: 'Controle de acesso', icone: iconControleAcesso, texto: 'Os sistemas de controle de acesso para condomínios gerenciam o fluxo de pessoas e veículos. Aumentam a segurança e garantem maior praticidade para o dia a dia de moradores e funcionários.' },
  { id: 'acesso-video', nome: 'Controle de acesso por vídeo', icone: iconControleVideo, texto: 'O videoporteiro para condomínios e casas é a solução ideal para quem busca mais segurança e comodidade no controle de acesso de visitantes. O morador pode visualizar a imagem do visitante e liberar a entrada, tudo a partir do monitor interno.' },
  { id: 'energia-solar', nome: 'Energia Solar', icone: iconEnergia, texto: 'Com os sistemas fotovoltaicos, os condomínios podem reduzir em até 95% a conta de energia das áreas comuns. Além da economia, o uso de energia solar ainda valoriza o empreendimento.' },
  { id: 'sensor-presenca', nome: 'Sensor de presença para iluminação', icone: iconPresenca, texto: 'Os sensores de presença acendem e apagam as luzes automaticamente, evitando o desperdício de energia. Devem ser instalados em ambientes onde a circulação de pessoas é constante, como corredores, halls e garagens.' },
  { id: 'infra-internet', nome: 'Infraestrutura para instalação de internet', icone: iconInfra, texto: 'Ter uma infraestrutura de qualidade garante uma internet mais veloz e estável em todos os apartamentos e áreas comuns. Além disso, ela facilita a instalação de novas tecnologias, como o monitoramento por vídeo e a automação predial.' },
  { id: 'radio', nome: 'Radiocomunicadores', icone: iconRadio, texto: 'Os radiocomunicadores garantem a comunicação instantânea entre a equipe do condomínio, mesmo em locais onde o sinal de celular é fraco. É uma ferramenta fundamental para agilizar o trabalho de porteiros, zeladores e seguranças.' },
  { id: 'iluminacao-emergencia', nome: 'Iluminação de emergência', icone: iconIluminacao, texto: 'Em caso de queda de energia, as luminárias de emergência acendem automaticamente, garantindo a visibilidade e a segurança dos moradores. É um item obrigatório, segundo as normas do Corpo de Bombeiros.' },
  { id: 'incendio', nome: 'Prevenção e detecção de incêndio', icone: iconIncendio, texto: 'Prevenção e detecção de incêndio são coisas sérias. Conte com a qualidade dos produtos Intelbras, que são eficientes e fáceis de instalar, e garantem que o prédio e o responsável civil e criminal do condomínio cumpram suas atribuições.' },
  { id: 'alarme-perimetral', nome: 'Alarmes e proteção perimetral', icone: iconAlarme, texto: 'Com as centrais de alarme, é possível criar uma barreira de proteção em muros, cercas e outros pontos vulneráveis. Quando o sistema detecta uma tentativa de invasão, ele dispara a sirene e avisa a empresa de monitoramento e o síndico por aplicativo.' },
  { id: 'cftv', nome: 'Câmeras e gravadores de segurança (CFTV)', icone: iconCftv, texto: 'Com as câmeras e gravadores Intelbras, o síndico consegue monitorar tudo o que acontece nas áreas comuns do condomínio, 24 horas por dia. E o melhor: as imagens podem ser acessadas remotamente, pelo celular ou computador.' },
];

// Dados da Galeria com legenda curta e descrição estendida
const galleryItems = [
    { image: galleryCercaEletrica, legenda: 'Cerca elétrica com ponteiras independentes', descricao: 'As cercas elétricas inibem a ação de invasores. A cada trecho rompido, o sistema envia um alerta para a central de monitoramento ou para o celular do síndico.' },
    { image: galleryLinhaVirtual, legenda: 'Linha virtual', descricao: 'Função inteligente que detecta a ultrapassagem de um perímetro pré-definido. Ideal para proteger os arredores de piscinas, portões de garagem, etc.' },
    { image: galleryCameraElevador, legenda: 'Câmera de segurança para elevadores', descricao: 'Soluções específicas para o monitoramento de elevadores, que garantem a gravação e a transmissão das imagens, mesmo com o movimento constante.' },
    { image: galleryAbandonoObjeto, legenda: 'Abandono ou retirada de objeto', descricao: 'O sistema alerta a central de monitoramento sempre que um objeto é abandonado ou retirado de um local pré-determinado, como em frente a saídas de emergência.' },
    { image: galleryIntertravamento, legenda: 'Intertravamento/eclusa', descricao: 'Sistema que impede que dois portões sejam abertos ao mesmo tempo, criando uma área de segurança para a triagem de pedestres e veículos.' },
    { image: galleryDeteccaoFace, legenda: 'Detecção de rosto', descricao: 'As câmeras com inteligência artificial detectam e reconhecem rostos cadastrados, permitindo criar um banco de dados de moradores e visitantes.' },
    { image: galleryCameraWifi, legenda: 'Câmera wi-fi para os apartamentos', descricao: 'Os moradores também podem ter o seu próprio sistema de segurança dentro de casa, com câmeras que transmitem as imagens em tempo real para o celular.' },
    { image: galleryCercaVirtual, legenda: 'Cerca Virtual', descricao: 'Use o sistema inteligente de câmeras para delimitar um espaço na vaga de pânico. Quando invadido, ativa o alarme ou notifica o síndico.' },
    { image: galleryEnergiaSolar, legenda: 'Energia solar para o condomínio', descricao: 'Reduza os custos das áreas comuns e valorize o imóvel com um sistema de energia fotovoltaica, uma solução sustentável e com retorno de investimento garantido.' },
    { image: galleryAntiEsmagamento, legenda: 'Sensores anti-esmagamento', descricao: 'Garanta a segurança de veículos e pedestres com sensores que revertem o fechamento do portão ao detectar qualquer obstáculo, evitando acidentes e danos.' },
    { image: galleryPortalAutonomo, legenda: 'Portal Condomínio Autônomo', descricao: 'Modernize a portaria com uma solução de atendimento remoto que otimiza o trabalho, reduz custos operacionais e aumenta a segurança no controle de acesso.' },
    { image: galleryMonitoramentoEnergia, legenda: 'Monitoramento de energia via Wi-Fi', descricao: 'Acompanhe o consumo de energia em tempo real através do aplicativo, permitindo uma gestão mais eficiente e consciente dos recursos do condomínio.' },
    { image: galleryAdeusChaves, legenda: 'Diga adeus à chave do apartamento', descricao: 'Instale fechaduras digitais e entre com senha ou biometria. Uma solução que oferece mais segurança, praticidade e um toque de modernidade ao seu lar.' },
    { image: galleryAppPrediotech, legenda: 'App Prediotech', descricao: 'Integre todas as soluções Intelbras em um único aplicativo, facilitando a comunicação, reserva de áreas comuns e o gerenciamento da segurança pelo síndico.' },
    { image: galleryPosteCFTV, legenda: 'Poste de CFTV Inteligente', descricao: 'Monitore ruas e áreas externas com postes de vigilância com câmera, botão de pânico e comunicação direta com a central. Aumente a percepção de segurança e iniba atividades suspeitas 24h por dia.' }
];

const ParaSeuCondominio = () => {
    const [solucaoAtiva, setSolucaoAtiva] = useState(solucoesCondominio[0]);
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide === bannerSlides.length - 1 ? 0 : prevSlide + 1));
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    const handleMouseOver = (solucao) => {
        setSolucaoAtiva(solucao);
    };
    
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Instalação de Sistemas de Segurança para Condomínios",
        "provider": {
            "@type": "ProfessionalService",
            "name": "Primo Trade Solutions LTDA",
            "telephone": "+55 11 9 7721-1739",
            "address": "Rua Eugene Carriere, 30, CJ6 T1, São Paulo, SP"
        },
        "areaServed": {
            "@type": "City",
            "name": "São Paulo"
        },
        "description": "Somos instaladores e revendedores autorizados de soluções Intelbras para condomínios. Oferecemos projetos completos de CFTV, controle de acesso, portaria remota e automação para valorizar e proteger seu patrimônio.",
        "name": "Soluções Intelbras para Condomínios - Instalação e Venda"
    };

    return (
        <div className="page-condominio">
            <Helmet>
                <title>Soluções para Condomínios - Segurança Intelbras | PTS</title>
                <meta name="description" content="Proteja e modernize seu condomínio com as soluções Intelbras. Somos especialistas em instalação de CFTV, controle de acesso, alarmes e mais. Peça um orçamento." />
                <meta property="og:title" content="Soluções Completas Intelbras para Condomínios | PTS" />
                <meta property="og:description" content="Segurança, comunicação e gestão otimizada para síndicos e moradores. Conheça nossas soluções como instaladores autorizados." />
                <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
            </Helmet>
            
            <section className="banner-slider">
                <div className="slider-wrapper" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                    {bannerSlides.map(slide => (
                        <div key={slide.id} className="slide" style={{ backgroundImage: `url(${slide.imagem})` }} />
                    ))}
                </div>
                <div className="slide-content">
                    <h2>{bannerSlides[currentSlide].titulo}</h2>
                    <p>{bannerSlides[currentSlide].subtitulo}</p>
                    <a href="#contato">Assista ao vídeo</a>
                </div>
                <div className="slider-dots">
                    {bannerSlides.map((_, index) => (
                        <div 
                            key={index} 
                            className={`dot ${currentSlide === index ? 'active' : ''}`}
                            onClick={() => setCurrentSlide(index)}
                        />
                    ))}
                </div>
            </section>

            <section className="condominio-hero" style={{ backgroundImage: `url(${bgInfografico})` }}>
                <div className="container">
                    <div className="hero-content">
                        <h1>Segurança e gestão do condomínio</h1>
                        <p>Nós, da Primo Trade Solutions, somos os parceiros ideais para implementar essa tecnologia. Cuidamos da instalação e configuração para que você, síndico ou morador, tenha total tranquilidade.</p>
                    </div>
                    <div className="infografico-container">
                        <div className="solucoes-wrapper">
                            {solucoesCondominio.map(sol => (
                                <div key={sol.id} className={`solucao-ponto ${sol.id}`} onMouseOver={() => handleMouseOver(sol)} onClick={() => handleMouseOver(sol)}>
                                    <img src={sol.icone} alt={sol.nome} title={sol.nome} />
                                </div>
                            ))}
                        </div>
                        {solucaoAtiva && (
                            <a href="#contato" className="solucao-tooltip">
                                <h3>{solucaoAtiva.nome}</h3>
                                <p>{solucaoAtiva.texto}</p>
                            </a>
                        )}
                    </div>
                </div>
            </section>

            <section id="solucoes-detalhes" className="condominio-section galeria-section">
                <div className="container">
                    <h2>Soluções que protegem e facilitam a rotina do condomínio</h2>
                    <p>Implementamos tecnologias que resolvem problemas reais do dia a dia, desde o controle de quem entra e sai até a prevenção de incidentes.</p>
                    <div className="galeria-grid">
                        {galleryItems.map((item, index) => (
                            <div key={index} className="galeria-item" style={{ backgroundImage: `url(${item.image})` }}>
                                <div className="galeria-legenda"> {/* NOVA DIV PARA A LEGENDA CURTA */}
                                    <h4>{item.legenda}</h4>
                                </div>
                                <div className="galeria-overlay">
                                    <h4>{item.legenda}</h4> {/* Repetir aqui para o overlay, se quiser */}
                                    <p>{item.descricao}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="condominio-section trust-section">
                <div className="container">
                    <h2>Parceria de Confiança</h2>
                    <p>Unimos a liderança de mercado da Intelbras com a nossa excelência em instalação e configuração para entregar a melhor solução para o seu condomínio.</p>
                    <div className="logos-container">
                        <div className="logo-placeholder">
                            <img src={logoPts} alt="Logo Primo Trade Solutions" />
                        </div>
                        <div className="plus-icon">+</div>
                        <div className="logo-placeholder">
                            <img src={logoIntelbras} alt="Logo Intelbras" />
                        </div>
                    </div>
                </div>
            </section>
            <section id="contato" className="condominio-section capture-section">
                <div className="container">
                    <h2>Seu condomínio está pronto para o próximo nível de segurança?</h2>
                    <p>
                        A demanda por condomínios mais seguros e tecnológicos está em alta. Agende uma visita técnica sem compromisso. Nossas vagas para análise de projetos são limitadas para garantir a máxima atenção a cada cliente. Preencha o formulário e garanta a sua.
                    </p>

                    {/* --- INÍCIO DO BLOCO A SER ADICIONADO --- */}
                    <div className="video-container">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/Cp_TlfIQRGA"
                            title="YouTube video player - Soluções para Condomínios Intelbras"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen>
                        </iframe>
                    </div>
                    <ContactForm />
                </div>
            </section>

        </div>
    );
};

export default ParaSeuCondominio;